module.exports = __webpack_public_path__ + "img/product.89aa5044.svg";